// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ACnyV","label":"styles_label__Z43In","description":"styles_description__Jo7FJ","input":"styles_input__WgOHg","error":"styles_error__HHt_u"};